// Web Bridge
import {
  registerHandler,
  unregisterHandler,
  WebBridgeEventListener,
} from '@shopee/web-bridge-sdk';

export function createTobSdkEventCallbackListener({
  onCallback,
  onError,
  scene,
}: {
  onCallback: ({ data }: { data: Record<string, any> }) => void;
  onError: () => void;
  scene: string;
}) {
  let listenerId: string | undefined;

  const register = () => {
    listenerId = registerHandler(
      WebBridgeEventListener.ToBSdkEventCallback,
      e => {
        if (e && typeof e === 'object' && e?.scene === scene) {
          onCallback({ data: e?.data });
        } else {
          onError();
        }
      }
    );
  };

  const clear = () => {
    unregisterHandler(WebBridgeEventListener.ToBSdkEventCallback, listenerId);
  };

  return {
    register,
    clear,
  };
}
